import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_undo.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconUndo = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconUndo;
